var map;
var InfoObj = [];
var markers = []; // Array para almacenar todos los marcadores

var icons = {
  adoc: {
    icon: 'https://cdn.shopify.com/s/files/1/0346/1893/3307/files/logo_adoc-min.png?v=1655323909'
  }
};

var markersOnMap = [
  {
    codestore: 'A27',
    placeName: 'ADOC Galerías Miraflores',
    storeAddress: 'CC Galerías Miraflores, 11 Av 4-22, Local 182, 183 y 184, Zona 11',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '24748365',
    whatsapp: '31516547',
    page: 'https://g.page/r/CWtCJxsksdktEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6215348,
      lng: -90.5532309
    }],
    type: 'adoc'
  },
  {
    codestore: 'A15',
    placeName: 'ADOC Oakland',
    storeAddress: 'CC Oakland Mall,Oakland Mall Local #207, Diagonal 6 13-01, Zona 10',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '31524617',
    whatsapp: '31516547',
    page: 'https://goo.gl/maps/g8daQ1u59X7nccWB9',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5987808,
      lng: -90.5074168
    }],
    type: 'adoc'
  },
  {
    codestore: 'A96',
    placeName: 'ADOC Pradera Concepción',
    storeAddress: 'CC Pradera Concepción, Local 101 y 102, Km 15.5 Ctra. a El Salvador,<br>Finca Condado Concepción, Zona 7, Santa Catarina Pinula',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '66371900',
    whatsapp: '31516547',
    page: 'https://g.page/r/CTYgFdg6w22KEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5540249,
      lng: -90.4533538
    }],
    type: 'adoc'
  },
  {
    codestore: 'A98',
    placeName: 'ADOC Peri-Roosevelt',
    storeAddress: 'CC Peri-Roosevelt, Zona 11, Local 16',
    schedule: 'Lunes a Domingo: 9:00am a 9:00pm',
    phone: '49922069',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6268824, 
      lng: -90.5552157
    }],
    type: 'adoc'
  },
  {
    codestore: 'A16',
    placeName: 'ADOC Portales',
    storeAddress: 'CC Portales, Km 4.5 3-20, Ctra al Atlantico, Zona 17, Local 226-227',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22564334',
    whatsapp: '31516547',
    page: 'https://goo.gl/maps/9ZSsUhUuP97aMqx88',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.647994, 
      lng: -90.4823494
    }],
    type: 'adoc'
  },
  {
    codestore: 'A12',
    placeName: 'ADOC Naranjo',
    storeAddress: 'CC Naranjo Mall, 23 Calle 10-00, 2o Nivel, Local L-227 y L-228, Zona 4, Mixco',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '22127379',
    whatsapp: '31516547',
    page: 'https://g.page/r/CUQlHm9E_SqOEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.650554, 
      lng: -90.5417971
    }],
    type: 'adoc'
  },
  {
    codestore: 'A04',
    placeName: 'ADOC Interplaza',
    storeAddress: 'CC Interplaza Xela, Local 126, Quezaltenango',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '77677358',
    whatsapp: '31516547',
    page: 'https://goo.gl/maps/cs254ajkD9pWydD4A',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.8625346,
      lng: -91.5502257
    }],
    type: 'adoc'
  }
];

// Función de búsqueda
document.getElementById('store-search').addEventListener('input', function(e) {
  const searchTerm = e.target.value.toLowerCase();
  
  document.querySelectorAll('.store-card').forEach(card => {
    const storeName = card.querySelector('.store-name').textContent.toLowerCase();
    const storeAddress = card.querySelectorAll('.store-info')[0].textContent.toLowerCase();
    
    if (storeName.includes(searchTerm) || storeAddress.includes(searchTerm)) {
      card.style.display = 'flex';
      
      // Resalta el texto coincidente
      if (searchTerm.length > 0) {
        highlightText(card, searchTerm);
      } else {
        removeHighlights(card);
      }
    } else {
      card.style.display = 'none';
    }
  });
  
  // También resaltar en el mapa
  highlightMarkers(searchTerm);
});

function highlightText(element, searchTerm) {
  removeHighlights(element);
  
  const regex = new RegExp(searchTerm, 'gi');
  const nodes = element.querySelectorAll('.store-name, .store-info');
  
  nodes.forEach(node => {
    const text = node.textContent;
    const html = text.replace(regex, match => `<span class="highlight">${match}</span>`);
    node.innerHTML = html;
  });
}

function removeHighlights(element) {
  const highlights = element.querySelectorAll('.highlight');
  highlights.forEach(highlight => {
    const parent = highlight.parentNode;
    parent.textContent = parent.textContent;
  });
}

function highlightMarkers(searchTerm) {
  markers.forEach(marker => {
    const title = marker.getTitle().toLowerCase();
    if (title.includes(searchTerm.toLowerCase())) {
      marker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(() => marker.setAnimation(null), 1500);
    }
  });
}

// Botón de ubicación
document.querySelector('.locate-me-btn').addEventListener('click', function() {
  if (navigator.geolocation) {
    this.textContent = "Buscando...";
    navigator.geolocation.getCurrentPosition(
      position => {
        positionOk(position);
        this.textContent = "📍 Mi ubicación";
      }, 
      error => {
        positionKO(error);
        this.textContent = "📍 Mi ubicación";
      }
    );
  } else {
    alert("La geolocalización no es soportada por tu navegador");
  }
});

function addMarkerInfo() {
  const storesContainer = document.getElementById('stores-container');
  
  for(var i = 0; i < markersOnMap.length; i++) {
    // Contenido para el InfoWindow
    var contentString = `
      <div class="info-window">
        <div class="info-store-name">${markersOnMap[i].placeName}</div>
        <div class="info-store-address">${markersOnMap[i].storeAddress}</div>
        <div class="info-store-schedule">${markersOnMap[i].schedule.replace(/<br>/g, '<br>• ')}</div>
        <div class="info-store-links">
          ${markersOnMap[i].phone !== "" ? `
          <a class="info-link" href="tel:+503${markersOnMap[i].phone}">
            <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Teléfono">
            (503) ${markersOnMap[i].phone}
          </a>` : ''}
          <a class="info-link" target="_blank" href="https://api.whatsapp.com/send?phone=503${markersOnMap[i].whatsapp}">
            <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="WhatsApp">
            (503) ${markersOnMap[i].whatsapp}
          </a>
          <a class="info-link" target="_blank" href="https://www.waze.com/ul?ll=${markersOnMap[i].LatLng[0].lat}%2C${markersOnMap[i].LatLng[0].lng}&navigate=yes&zoom=17">
            <img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Waze">
            Navegar en Waze
          </a>
          
          ${markersOnMap[i].review !== "" ? `
          <a class="info-link review-link" target="_blank" href="${markersOnMap[i].review}">
            <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/review-icon-min.png?v=1643988824" alt="Reseña">
            Agregar Reseña
          </a>` : ''}
        </div>
      </div>
    `;

    // Contenido para la lista de tiendas
    var contentDiv = `
      <div class="store-card" onclick="SetCenterMap(${markersOnMap[i].LatLng[0].lat},${markersOnMap[i].LatLng[0].lng}); highlightMarker('${markersOnMap[i].storecode}')">
        <div class="store-name">${markersOnMap[i].placeName}</div>
        <div class="store-info">${markersOnMap[i].storeAddress}</div>
        <div class="store-info">${markersOnMap[i].schedule.replace(/<br>/g, ' • ')}</div>
        <div class="store-contact">
          ${markersOnMap[i].phone !== "" ? `
          <a class="contact-link" href="tel:+503${markersOnMap[i].phone}">
            <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Teléfono">
            (503) ${markersOnMap[i].phone}
          </a>` : ''}
          <a class="contact-link" target="_blank" href="https://api.whatsapp.com/send?phone=503${markersOnMap[i].whatsapp}">
            <img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="WhatsApp">
            (503) ${markersOnMap[i].whatsapp}
          </a>
          <a class="contact-link" target="_blank" href="https://www.waze.com/ul?ll=${markersOnMap[i].LatLng[0].lat}%2C${markersOnMap[i].LatLng[0].lng}&navigate=yes&zoom=17">
            <img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Waze">
            Navegar en Waze
          </a>
          
          ${markersOnMap[i].review !== "" ? `
          <button class="review-btn">
            <a target="_blank" href="${markersOnMap[i].review}">Agregar Reseña</a>
          </button>` : ''}
        </div>
      </div>
    `;

    // Añadir la tarjeta al contenedor
    storesContainer.innerHTML += contentDiv;

    // Crear el marcador
    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map,
      title: markersOnMap[i].placeName,
      storecode: markersOnMap[i].storecode
    });

    // Almacenar el marcador
    markers.push(marker);

    // Crear la ventana de información
    const infowindow = new google.maps.InfoWindow({
      content: contentString,
      maxWidth: 300
    });

    // Evento click para el marcador
    marker.addListener('click', function() {
      closeOtherInfo();
      infowindow.open(map, marker);
      InfoObj[0] = infowindow;
      
      // Resaltar la tarjeta correspondiente
      highlightStoreCard(markersOnMap[i].storecode);
    });
  }
}

function highlightMarker(storecode) {
  markers.forEach(marker => {
    if (marker.storecode === storecode) {
      marker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(() => marker.setAnimation(null), 1500);
      
      // Abrir el InfoWindow
      google.maps.event.trigger(marker, 'click');
    }
  });
}

function highlightStoreCard(storecode) {
  // Remover resaltado previo
  document.querySelectorAll('.store-card').forEach(card => {
    card.style.backgroundColor = '';
    card.style.border = 'none';
  });
  
  // Resaltar la tarjeta correspondiente
  const card = document.querySelector(`.store-card[onclick*="${storecode}"]`);
  if (card) {
    card.style.backgroundColor = '#fff9e6';
    card.style.border = '2px solid var(--primary-color)';
    card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}

function closeOtherInfo() {
  if (InfoObj.length > 0) {
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon) {
  const centerStore = { lat: posLat, lng: posLon };
  map.setCenter(centerStore);
  map.setZoom(16);
}

function positionOk(pos) {
  const latitudeMap = pos.coords.latitude;
  const longitudMap = pos.coords.longitude;
  const centerStore = { lat: latitudeMap, lng: longitudMap };
  
  map.setCenter(centerStore);
  map.setZoom(14);
  
  // Agregar marcador de ubicación actual
  new google.maps.Marker({
    position: centerStore,
    map: map,
    icon: {
      url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png"
    },
    title: "Tu ubicación actual"
  });
}

function positionKO(error) {
  console.error("Error obteniendo ubicación:", error);
  const centerStore = { lat: 13.7063894, lng: -89.2124064 };
  map.setCenter(centerStore);
  
  // Mostrar alerta solo si el usuario no denegó el permiso
  if (error.code !== error.PERMISSION_DENIED) {
    alert("No pudimos determinar tu ubicación. Mostrando vista por defecto.");
  }
}

function initMap() {
  map = new google.maps.Map(document.getElementById('map'), {
    zoom: 13,
    center: { lat: 13.7063894, lng: -89.2124064 },
    mapId: '46642173f0d6b463',
    styles: [
      {
        "featureType": "poi",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "featureType": "transit",
        "stylers": [{ "visibility": "off" }]
      }
    ]
  });

  // Intenta obtener la ubicación del usuario
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);
  }

  addMarkerInfo();
}